import axiosInstance from '@/utils/api.js'

var state = {
  radiusAttr: [],
  radiusAttrAccounts: [],
  radiusAttrISGprofile: [],
  radiusAttrISGcoa: []
}

var getters = {
  RADIUS_ATTR: (state) => {
    return state.radiusAttr
  },
  RADIUS_ATTR_ACCOUNTS: (state) => {
    return state.radiusAttrAccounts
  },
  RADIUS_ATTR_ISG_PROFILE: (state) => {
    return state.radiusAttrISGprofile
  },
  RADIUS_ATTR_ISG_COA: (state) => {
    return state.radiusAttrISGcoa
  }
}

var mutations = {
  SET_RADIUS_ATTR: (state, payload) => {
    state.radiusAttr = payload
  },
  SET_RADIUS_ATTR_ACCOUNTS: (state, payload) => {
    state.radiusAttrAccounts = payload
  },
  SET_RADIUS_ATTR_ISG_PROFILE: (state, payload) => {
    state.radiusAttrISGprofile = payload
  },
  SET_RADIUS_ATTR_ISG_COA: (state, payload) => {
    state.radiusAttrISGcoa = payload
  }
}

var actions = {
  GET_RADIUS_ATTR_NAS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=0')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR', result.data)
    }
  },
  GET_RADIUS_ATTR_ACCOUNTS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=12')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ACCOUNTS', result.data)
    }
  },
  GET_RADIUS_ATTR_ISG_PROFILE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=7')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_PROFILE', result.data)
    }
  },
  GET_RADIUS_ATTR_ISG_COA: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/radius_attrs?object_id=' + payload + '&object_type=8')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ATTR_ISG_COA', result.data)
    }
  },
  UPDATE_RADIUS_ATTR: (context, payload) => {
    return axiosInstance.put('/tariffing/radius_attrs', payload)
  },
  DELETE_RADIUS_SESSION: (context, payload) => {
    return axiosInstance.delete('/additional/radius_session?slink_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/radiusAttr.js